export default "__VITE_ASSET__C4EBkZGn__"